import React from 'react'; // eslint-disable-line import/no-extraneous-dependencies

import cardStyles from '../card.module.css';

import MainCard from './components/mainCard';
import AboutCard from './components/aboutCard';

const Home = () => ([
  <div key="firstCard" className={`${cardStyles.halfCardContainer} ${cardStyles.firstCard}`}>
    <MainCard />
  </div>,
  <div key="secondCard" className={cardStyles.halfCardContainer}>
    <AboutCard />
  </div>,
]);


export default Home;



// WEBPACK FOOTER //
// ./src/pageComponents/home/index.jsx